import React from 'react';

// The unread marker after "What's new" in the sidebar.
const NewUpdatesDot = () => (
  <span
    className="ml-2 h-2 w-2 shrink-0 rounded-full bg-blue-600 dark:bg-sky-400"
    role="status"
    aria-label="New updates"
  />
);

export default NewUpdatesDot;
